import AssessmentReportWidget from "./AssessmentReportWidget";

export default AssessmentReportWidget